import { GET_WORD_BANK, REMOVE_FROM_CURRENT_3, REMOVE_IGNORED_WORD } from "../actions/types"


const initialState = {
    allKnownWords: null,
    ignoredWords: null,
    wordBank: null
}

export const wordBankReducer = (state = initialState, { type, payload }) => {

    switch (type) {

        case GET_WORD_BANK:
            payload.wordBank.forEach((element) => {
                let shouldReplaceWith = payload.allKnownWords.indexOf(element.word.word);
                if (shouldReplaceWith > -1) {
                    payload.allKnownWords.splice(shouldReplaceWith, 1);
                }
            })

            return { ...payload }
        case REMOVE_FROM_CURRENT_3:
            return { ...state, allKnownWords: payload.allKnownWords }
        case REMOVE_IGNORED_WORD:
            return { ...state, allKnownWords: payload.allKnownWords, ignoredWords: payload.ignoredWords };
        default:
            return state
    }
}
export default wordBankReducer;